export default __webpack_public_path__ + "static/Meet Paul illu-bf2a58fb3f25683f97c87bdcc2ff3f2e.png";